import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		relativeContainer: {
			position: 'relative',
		},
		filterButtonContainer: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-end',
		},
		subHeaderContent: {
			marginBottom: '10px',
		},
		filterButton: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-end',
			marginRight: 10,
		},
		backBtn: {
			position: 'relative',
			marginRight: 'auto',
			marginBottom: 0,
			left: '1em',
			height: 30,
			width: 100,
			background: 'rgba(0, 0, 0, 0.2)',
			color: '#fff',
			border: '1px solid #fff',
			borderRadius: '20px',
			padding: '0px 20px',
			paddingRight: '25px',
			alignItems: 'center',
			textTransform: 'none',
		},
		backBtnText: {
			paddingRight: '2px',
		},
	})
